export default __webpack_public_path__ + "static/media/11.ede5c4b4.svg";